import { isValidIntlLocale } from "@wayflyer/flyui";

export type CustomerLanguage = "en" | "de" | "es";

export const getLocale = () => (isValidIntlLocale(navigator.language) ? navigator.language : "en");

export const getCustomerLanguage = (locale: string): CustomerLanguage => {
  const language = locale.toLowerCase().split("-")[0];

  return language === "de" || language === "es" ? language : "en";
};
